import { useSelector } from 'react-redux';

import type {
  ProgrammaticAdviceRecoLevel,
  ProgrammaticAdviceRecoProduct,
} from '@/digitalAdvice/Recommendation/ProgrammaticAdviceReco.model';
import { selectProgrammaticAdviceRecoProducts } from '@/digitalAdvice/Recommendation/ProgrammaticAdviceReco.selectors';

type UseProgrammaticAdviceReco = () => [
  ProgrammaticAdviceRecoLevel,
  ProgrammaticAdviceRecoProduct,
][];

export const useProgrammaticAdviceReco: UseProgrammaticAdviceReco = () => {
  const products = useSelector(selectProgrammaticAdviceRecoProducts) || [];
  if (products.length >= 2) return products;
  return [];
};
